import React from "react";
import Donatenow from "../imgs/DonateNow.png";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaHeart,
  FaHandHoldingHeart,
  FaExternalLinkAlt,
} from "react-icons/fa";

const Contatti = () => {
  return (
<div className="flex flex-col items-center w-full min-h-screen bg-gradient-to-r from-white to-amber-50 text-gray-800 overflow-hidden">      
      {/* DECORAZIONI DI SFONDO */}
      <div className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-red-100/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-amber-200/40 blur-3xl" />

      <main className="relative z-10 mx-auto flex w-11/12 max-w-5xl flex-col items-center  pb-5">

        {/* =========================================================
            INTESTAZIONE
        ========================================================= */}
        <header className="mb-10 text-center">
          <h1 className="text-4xl font-extrabold tracking-wide text-red-600 md:text-5xl">
            Contatti
          </h1>

          <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-gray-600 md:text-lg">
            Hai bisogno di informazioni, vuoi collaborare con MilArte o
            sostenere le nostre attività? Scrivici o vieni a trovarci.
          </p>

        </header>


        {/* =========================================================
            CONTATTI + SEDE
        ========================================================= */}
        <section className="grid w-full gap-6 md:grid-cols-2">

          {/* ---------------------------------------------------------
              CARD CONTATTI
          --------------------------------------------------------- */}
          <div className="rounded-3xl border border-amber-100 bg-white/80 p-6 shadow-xl backdrop-blur-md md:p-8">

            <div className="mb-7 flex items-center gap-4">

              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-red-50 text-2xl text-red-600">
                <FaEnvelope />
              </span>

              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Parliamo di musica
                </h2>

                <p className="mt-1 text-sm text-gray-500">
                  Per informazioni e richieste
                </p>
              </div>

            </div>


            <div className="space-y-4">

              {/* EMAIL */}
              <a
                href="mailto:milarte.mi@gmail.com"
                className="group flex items-center gap-4 rounded-2xl border border-gray-100 bg-gray-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-red-100 hover:bg-red-50 hover:shadow-md"
              >

                <FaEnvelope className="shrink-0 text-lg text-red-600" />

                <span className="break-all text-sm font-medium text-gray-700 transition-colors group-hover:text-red-700 md:text-base">
                  milarte.mi@gmail.com
                </span>

              </a>


              {/* PEC */}
              <a
                href="mailto:milarte.mi@pec.it"
                className="group flex items-center gap-4 rounded-2xl border border-gray-100 bg-gray-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-red-100 hover:bg-red-50 hover:shadow-md"
              >

                <FaEnvelope className="shrink-0 text-lg text-red-600" />

                <span className="break-all text-sm font-medium text-gray-700 transition-colors group-hover:text-red-700 md:text-base">
                  milarte.mi@pec.it
                </span>

              </a>


              {/* TELEFONO */}
              <a
                href="tel:+393388303778"
                className="group flex items-center gap-4 rounded-2xl border border-gray-100 bg-gray-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-red-100 hover:bg-red-50 hover:shadow-md"
              >

                <FaPhoneAlt className="shrink-0 text-lg text-red-600" />

                <span className="flex flex-1 flex-wrap items-center gap-2 text-sm font-medium text-gray-700 md:text-base">

                  <span>
                    Giuseppe Dinardo: +39 338 830 3778
                  </span>

                  <FaExternalLinkAlt className="text-xs text-gray-400 transition-colors group-hover:text-red-500" />

                </span>

              </a>

            </div>

          </div>


          {/* ---------------------------------------------------------
              CARD SEDE
          --------------------------------------------------------- */}
          <div className="rounded-3xl border border-amber-100 bg-white/80 p-6 shadow-xl backdrop-blur-md md:p-8">

            <div className="mb-7 flex items-center gap-4">

              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-amber-100 text-2xl text-amber-700">
                <FaMapMarkerAlt />
              </span>

              <div>

                <h2 className="text-2xl font-bold text-gray-900">
                  Dove trovarci
                </h2>

                <p className="mt-1 text-sm text-gray-500">
                  La nostra sede
                </p>

              </div>

            </div>


            <div className="flex min-h-[180px] items-center justify-center rounded-2xl bg-gradient-to-br from-red-50 to-amber-50 p-6 text-center">

              <div>

                <FaMapMarkerAlt className="mx-auto mb-4 text-4xl text-red-600" />

                <p className="text-lg font-semibold leading-relaxed text-gray-800">
                  MilArte
                  <br />
                  Via Giovanni Scheiwiller, 7
                  <br />
                  20139 Milano
                </p>

              </div>

            </div>

          </div>

        </section>


        {/* =========================================================
            DONAZIONI
        ========================================================= */}
        <section className="mt-8 w-full overflow-hidden rounded-3xl bg-red-700 p-6 text-white shadow-xl md:p-10">

          <div className="flex flex-col items-center gap-8 md:flex-row md:justify-between">

            {/* TESTO */}
            <div className="max-w-xl text-center md:text-left">

              <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-amber-200">

                <FaHandHoldingHeart />

                Sostieni MilArte

              </span>


              <h2 className="mt-3 text-3xl font-extrabold md:text-4xl">
                Aiutaci a far crescere la musica
              </h2>


              <p className="mt-4 text-base leading-relaxed text-red-50 md:text-lg">
                Le donazioni liberali ci permettono di continuare a promuovere
                concerti, eventi e iniziative culturali.
              </p>


              {/* IBAN */}
              <div className="mt-5 rounded-2xl bg-white/10 p-4 backdrop-blur-sm">

                <p className="text-xs font-semibold uppercase tracking-wider text-amber-200">
                  IBAN
                </p>

                <p className="mt-1 break-all font-mono text-sm text-white md:text-base">
                  IT19M0760101600001067558849
                </p>

              </div>

            </div>


            {/* IMMAGINE DONAZIONE */}
            {/* <div className="w-full max-w-xs shrink-0 rounded-2xl bg-white p-3 shadow-2xl transition-transform duration-300 hover:-translate-y-1 hover:scale-[1.02]">

              <img
                src={Donatenow}
                alt="Indicazioni per effettuare una donazione a MilArte"
                className="w-full rounded-xl"
              />

            </div> */}
{/* ICONA DONAZIONE */}
<div className="flex w-full max-w-xs shrink-0 items-center justify-center">

  <div className="group flex h-48 w-48 items-center justify-center rounded-full bg-white/10 backdrop-blur-sm shadow-2xl transition-all duration-500 hover:scale-105 hover:bg-white/15">

    <div className="flex h-36 w-36 items-center justify-center rounded-full bg-amber-200 text-red-700 shadow-inner transition-all duration-500 group-hover:rotate-3">

      <FaHandHoldingHeart className="text-7xl" />

    </div>

  </div>

</div>
          </div>

        </section>


      </main>

    </div>
  );
};

export default Contatti;